/**
 * Production-safe logger
 * Only logs in development, silent in production
 */

const isDevelopment = process.env.NODE_ENV === 'development' ||
                      globalThis.location?.hostname === 'localhost' ||
                      globalThis.location?.hostname?.includes('127.0.0.1');

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },

  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  group: (...args: any[]) => {
    if (isDevelopment) {
      console.group(...args);
    }
  },

  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },

  // Mask sensitive data
  logAuth: (message: string, data?: Record<string, any>) => {
    if (isDevelopment) {
      if (data && typeof data === 'object') {
        const sanitized: Record<string, any> = { ...data };
        // Mask sensitive fields
        if (sanitized.password) sanitized.password = '***';
        if (sanitized.token) sanitized.token = String(sanitized.token).substring(0, 10) + '...';
        if (sanitized.Authorization) sanitized.Authorization = 'Bearer ***';
        console.log(message, sanitized);
      } else {
        console.log(message, data);
      }
    }
  }
};

export default logger;
